import { render } from "./AccountLayout.vue?vue&type=template&id=4559e1ab&scoped=true"
import script from "./AccountLayout.vue?vue&type=script&lang=js"
export * from "./AccountLayout.vue?vue&type=script&lang=js"

import "./AccountLayout.vue?vue&type=style&index=0&id=4559e1ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4559e1ab"]])

export default __exports__